var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hintDataText)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.left",value:(_vm.hintDataText || _vm.text),expression:"hintDataText || text",modifiers:{"left":true}}],staticClass:"tooltip-icon"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }